"use client";

import { useCallback, useState } from "react";

import cn from "classnames";

import { Accordion } from "@/components/accordion/accordion.component";
import { RichText } from "@/components/richText/richText.component";

import { FaqSection as FaqSectionType, Theme } from "@/sanity.types";

export const FaqAccordionList = ({
  faqs,
  theme,
  isCenteredLayout,
  isMonitoringPage,
}: FaqAccordionListProps) => {
  const [expandedFaqKey, setExpandedFaqKey] = useState<string | null>(null);

  const handleAccordionToggle = useCallback((key: string, isOpen: boolean) => {
    setExpandedFaqKey((currentKey) => {
      if (isOpen) return key;
      if (currentKey === key) return null;
      return currentKey;
    });
  }, []);

  return faqs.map((faq) => (
    <Accordion
      key={faq._key}
      title={faq.question}
      titleVariant={isCenteredLayout ? "body3" : "h6"}
      isExpanded={expandedFaqKey === faq._key}
      isCollapsible={true}
      theme={theme}
      onToggle={(isOpen) => handleAccordionToggle(faq._key, isOpen)}
      arrowSize={isCenteredLayout ? 16 : 24}
      flush={isCenteredLayout}
      summaryClassName={cn({
        "py-2 group-not-first:py-2": isCenteredLayout,
        "!text-greyscale-headline": isMonitoringPage,
      })}
      contentClassName={cn({
        "pb-5 text-greyscale-body": isCenteredLayout,
      })}>
      <RichText>{faq.answer}</RichText>
    </Accordion>
  ));
};

type FaqAccordionListProps = {
  faqs: FaqSectionType["faqs"];
  theme?: Theme;
  isCenteredLayout: boolean;
  isMonitoringPage: boolean;
};
